export const TimeSheetTypes = {
    GET_TIME_SHEET_CLEANER: "GET_TIME_SHEET_CLEANER",
    CLEAR_TIME_SHEET_CLEANER: "CLEAR_TIME_SHEET_CLEANER",    
    GET_TIME_SHEET: "GET_TIME_SHEET",
    CLEAR_TIME_SHEET: "CLEAR_TIME_SHEET",

}